import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {ToastAlert} from '../../model/toast-alert';


export type ToastAlertState = {
  toastAlerts: ToastAlert[]
};

const initialState: ToastAlertState = {
  toastAlerts: []
};

export const ToastAlertSignalStore = signalStore(
  {providedIn: 'root'},
  withState(initialState),
  withMethods((store) => ({
    addToastAlert(toastAlert: ToastAlert): void {
      patchState(store, {toastAlerts: [...store.toastAlerts(), toastAlert]});
    },
    success(message: string): void {
      const toastAlert: ToastAlert = new ToastAlert('success', message);
      patchState(store, {toastAlerts: [...store.toastAlerts(), toastAlert]});
    },
    info(message: string): void {
      const toastAlert: ToastAlert = new ToastAlert('info', message);
      patchState(store, {toastAlerts: [...store.toastAlerts(), toastAlert]});
    },
    warning(message: string): void {
      const toastAlert: ToastAlert = new ToastAlert('warning', message);
      patchState(store, {toastAlerts: [...store.toastAlerts(), toastAlert]});
    },
    danger(message: string): void {
      const toastAlert: ToastAlert = new ToastAlert('danger', message);
      patchState(store, {toastAlerts: [...store.toastAlerts(), toastAlert]});
    }
  }))
);
